module.exports = __webpack_public_path__ + "tables/media/Vector-4.ec4a6468.svg";